//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    link: String
  },
  data () {
    return {
      visited: false
    }
  }
}

